import React, { useState } from 'react';
import get from 'lodash/get';
import axios from 'axios';
import _, { uniqueId } from 'lodash';
import { SdfAlert, SdfButton, SdfFocusPane, SdfIcon, SdfInput } from '@synerg/react-components';

export default function DeletePartner({ setDeletedPartner, orgName, ooid, closeDeletePartnerModal, hideDeletePartnerModal }) {
	const [success, setSuccess] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [load, setLoading] = useState(null);
	const [isValidName, setIsValidName] = useState(null);
	const [isNameEmpty, setIsNameEmpty] = useState(true);
	const trimmedName = _.trim(orgName).toLowerCase().replace(/[ ,.]/g, '');

	const onHide = () => {
		hideDeletePartnerModal();
	}
	const onPartnerNameChange = (pn) => {
		if (pn.length > 0) {
			setIsNameEmpty(false);
			if (trimmedName === _.trim(pn).toLowerCase().replace(/[ ,.]/g, '')) {
				setIsValidName(true);
			} else {
				setIsValidName(false);
			}
		} else {
			setIsNameEmpty(true);
		}
	}
	const onClickDone = () => {
		if (setDeletedPartner) {
			setDeletedPartner(true);
		}
		closeDeletePartnerModal();
	}
	const deletePartner = async () => {
		try {
			setLoading(true);
			setErrorMessage('');
			const { data: { success } } = await axios.post(`${import.meta.env.VITE_ROOT_PATH}/api/partner/delete/${ooid}`);
			if (!success) {
				setSuccess(false);
				setLoading(false);
				setErrorMessage('Something went wrong.');
				return;
			}
			setSuccess(true);
		} catch (e) {
			setSuccess(false);
			setErrorMessage(get(e, 'response.data.message', 'Something went wrong.'));
		}
		setLoading(false);
	}

	return (<SdfFocusPane
		paneType="floating"
		visible={true}
		size="md"
		closeable={true}
		dismissOnClickOutside={true}
		hideAcceptButton={true}
		hideDismissButton={true}
		onSdfDismiss={onHide}
		heading="Delete Partner"
	>
		<div className="px-10">
			{errorMessage &&
				<SdfAlert
					key={uniqueId()}
					status={'error'}
					showToast={true}>
					<span slot="title"> Error </span>
					<div>{errorMessage || 'something went wrong while deleting partner.'}</div>
				</SdfAlert>}
			{!success && <p className="text-body-02">Please type in the partner name to confirm delete.</p>}
			{success &&
				<SdfAlert
					key={uniqueId()}
					status={'success'}
					showToast={true}>
					<span slot="title"> Success </span>
					<div>{`${orgName} has been deleted `}</div>
				</SdfAlert>}
			<p className="text-body-02">The partner will be deleted from Self-Service tool. The partner can be added back via legacy partner import.</p>
			{!success && <div className="mt-8 mb-5">
				<div>
					<SdfInput
						label={`Project name: ${orgName}`}
						inputWidth="xl"
						state={(!isValidName && !isNameEmpty) ? "error" : "normal"}
						placeholder={orgName}
						onSdfInput={({ detail }) => { onPartnerNameChange(detail) }} />
				</div>
				{isValidName && <div className="mt-1 text-body-02 text-alert-success"><SdfIcon icon="alert-success" />&nbsp;Valid</div>}
				{!isValidName && !isNameEmpty && <div className="mt-1 text-body-02 text-alert-error"><SdfIcon icon="alert-warning" />&nbsp;Wrong partner name</div>}
			</div>}
		</div>
		<div slot={"custom-buttons"} style={{ gap: "1rem" }}>
			<SdfButton onClick={success ? onClickDone : onHide}> {success ? 'Done' : 'Cancel'} </SdfButton>
			{!success && <SdfButton {...((!isValidName || isNameEmpty) && { disabled: true })} emphasis="primary" onClick={deletePartner} busy={load}>Delete</SdfButton>}
		</div>
	</SdfFocusPane>);
}
